import SettingsTabBase from "./SettingsTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { assignViewsState } from "../../../other/utils/otherUtils.jsx";
import {getFontAwesomeClassName} from "../../../other/utils/utils.jsx";
import { cellMenuItemRemoveRow } from "../../../other/utils/gridCellMenuUtils.jsx";

export default class SwivuSettingsIconsTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsIconsTab";
  }

  static get type() {
    return "swivusettingsIconstab";
  }

  static getGridWidget({ headerText, defaultValue }) {
    return {
      type: WIDGET_KEYS.swivuGrid,
      cls: "tag-grid-container",
      width: "100%",
      flex: "1 1 0%",
      features: {
        sort: false,
        group: false,
        rowReorder: { showGrip: true },
        stripe: { disabled: true },
        cellMenu: {
          items: {
            cut: false,
            copy: false,
            paste: false,
            removeRow: cellMenuItemRemoveRow()
          }
        }
      },
      listeners: {
        paint() {
          this.owner.loadGridData();
        }
      },
      columns: [
        {
          id: "tagValue",
          text: headerText,
          flex: 1,
          field: "tagValue",
          editable: true,
          editor: {
            placeholder: defaultValue
          },
          groupRenderer({ groupRowFor }) {
            return `<i class='fa fa-${getFontAwesomeClassName(groupRowFor)}' />`;
          },
          renderer({ value }) {
            return {
              children: [
                {
                  tag: "i",
                  class: `fa ${getFontAwesomeClassName(value)}`,
                }
              ]
            }
          },
          finalizeCellEdit: "up.onFinalizeTitleField"
        }
      ],
      bbar: [
        {
          type: "button",
          icon: "b-fa b-fa-plus",
          color: "b-green"
        },
        {
          type: "button",
          icon: "b-fa b-fa-trash",
          color: "b-red"
        }
      ]
    };
  }

  assignListenersToToolbarButtons(gridWidget, tagType) {
    gridWidget.bbar.firstItem.removeAllListeners();
    gridWidget.bbar.lastItem.removeAllListeners();
    gridWidget.bbar.firstItem.on("click", () =>
      this.onAdd(tagType, gridWidget)
    );
    gridWidget.bbar.lastItem.on("click", () =>
      this.onRemove(tagType, gridWidget)
    );
    gridWidget.features.cellMenu.items.removeRow.onItem = () => this.onRemove(tagType, gridWidget);
  }

  attachState(gridWidget, widgetRef) {
    gridWidget.stateId = `b-settings-tab-${widgetRef}`;
    assignViewsState([gridWidget], this.stateProvider);
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    this.swivuStore = this.project.getCrudStore(this.getStoreName());

    const tagWithWidgetRef = this.getTagKeysWithWidgetRef();

    Object.keys(tagWithWidgetRef).forEach((tagType) => {
      const widgetRef = tagWithWidgetRef[tagType];
      const gridWidget = this.widgetMap[widgetRef];
      this.assignListenersToToolbarButtons(
        gridWidget,
        tagType
      );
      this.loadGridData();
      gridWidget.store.swivuMasterStore = this.swivuStore;
      this.attachState(gridWidget, widgetRef);
    });
  }

  loadGridData() {
    if(this.swivuStore) {
      const tagWithWidgetRef = this.getTagKeysWithWidgetRef();
      Object.keys(tagWithWidgetRef).forEach((tagType) => {
        const widgetRef = tagWithWidgetRef[tagType];
        const gridWidget = this.widgetMap[widgetRef];
        gridWidget.store.data = this.swivuStore.query((record) => record.tagSet === tagType, true);
      });
    }
  }

  onAdd(tagType, gridWidget) {
    const lastItemOrder = gridWidget.store.last?.order;
    const currentItemOrder = lastItemOrder ? lastItemOrder + 1 : 0;
    const newRecord = this.swivuStore.createRecord({
      tagSet: tagType,
      tagValue: "",
      order: currentItemOrder
    });

    gridWidget.store.add(newRecord);
    gridWidget.startEditing({ record: newRecord, field: "tagValue" });
  }

  onRemove(tagType, gridWidget) {
    const selectedRecords = gridWidget.selectedRecords;
    if (selectedRecords.length) {
      const selectedIds = selectedRecords.map((record) => record.id);
      gridWidget.store.remove(selectedIds);
      this.swivuStore.remove(selectedIds);
    }
  }

  onFinalizeTitleField({ grid, value, record, oldValue }) {
    const cellValue = value.trim();
    const existingMatch = grid.store.find(iconRecord => iconRecord.tagValue.toLowerCase() === cellValue.toLowerCase());

    if (existingMatch) {
      return "Icon already exists";
    }

    if (cellValue) {
      if (record.isPhantom) this.swivuStore.add(record)
    } else {
      setTimeout(() => record.tagValue = oldValue)
    }
    return true;
  }

  static getDefaultLayoutSettings() {
    return {
      margin: "10px",
      cls: "swivu-board-tags-tab-container"
    };
  }
}
